import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { Calendar, Clock, CheckCircle2 } from "lucide-react";
import "./ContactHero.css";

const ContactHero = () => {
  const heroRef = useRef(null);
  const badgeRef = useRef(null);
  const headlineRef = useRef(null);
  const descriptionRef = useRef(null);
  const stepsRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ delay: 0.2 });

      tl.from(badgeRef.current, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: "power3.out",
      })
        .from(
          headlineRef.current,
          {
            opacity: 0,
            y: 40,
            duration: 1,
            ease: "power3.out",
          },
          "-=0.5",
        )
        .from(
          descriptionRef.current,
          {
            opacity: 0,
            y: 30,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.6",
        )
        .from(
          stepsRef.current.children,
          {
            opacity: 0,
            y: 20,
            duration: 0.6,
            stagger: 0.15,
            ease: "power2.out",
          },
          "-=0.4",
        );
    }, heroRef);

    return () => ctx.revert();
  }, []);

  const steps = [
    {
      icon: <Calendar size={24} strokeWidth={1.5} />,
      text: "Pick your perfect time",
    },
    {
      icon: <Clock size={24} strokeWidth={1.5} />,
      text: "Choose 30 or 60 minutes",
    },
    {
      icon: <CheckCircle2 size={24} strokeWidth={1.5} />,
      text: "Get instant confirmation",
    },
  ];

  return (
    <section className="contact-hero" ref={heroRef}>
      <div className="contact-hero__container">
        <div className="contact-hero__badge" ref={badgeRef}>
          BOOK YOUR FREE STRATEGY CALL
        </div>
        <h1 className="contact-hero__headline" ref={headlineRef}>
          Let's Build Your{" "}
          <span className="contact-hero__highlight">Growth System</span>
        </h1>
        <p className="contact-hero__description" ref={descriptionRef}>
          Schedule a free consultation with our team. We'll analyze your current
          marketing, identify opportunities, and show you exactly how to scale
          your aesthetic clinic.
        </p>

        <div className="contact-hero__steps" ref={stepsRef}>
          {steps.map((step, index) => (
            <div key={index} className="contact-hero__step">
              <div className="contact-hero__step-icon">{step.icon}</div>
              <div className="contact-hero__step-text">{step.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
